import { render, staticRenderFns } from "./PlaceFormModal.vue?vue&type=template&id=3207ceec"
import script from "./PlaceFormModal.vue?vue&type=script&lang=js"
export * from "./PlaceFormModal.vue?vue&type=script&lang=js"
import style0 from "./PlaceFormModal.vue?vue&type=style&index=0&id=3207ceec&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3207ceec')) {
      api.createRecord('3207ceec', component.options)
    } else {
      api.reload('3207ceec', component.options)
    }
    module.hot.accept("./PlaceFormModal.vue?vue&type=template&id=3207ceec", function () {
      api.rerender('3207ceec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/modal/PlaceFormModal.vue"
export default component.exports